export function isPecualiarAddressFormCountry(locale) {
    if (!locale || !locale.alias) {
        return false
    }

    if (locale.alias === 'ja-jp') {
        return true
    }

    return false
}
